import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextLargeParagraphTitleProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextLargeParagraphTitle = ({
  label,
  color = 'text-ds-natural',
  ellipsis,
}: TextLargeParagraphTitleProps) => (
  <Typography
    color={color}
    label={label}
    ellipsis={ellipsis}
    tagName="h4"
    fontSize="text-ds-500"
    lineHeight="leading-ds-400"
    fontWeight="font-ds-medium"
  />
);
